import Swiper from "swiper/bundle";
import "swiper/css/bundle";
// import "swiper/css/navigation";
// import "swiper/css/pagination";

document.addEventListener("DOMContentLoaded", function () {
  const artificialSliders = document.querySelectorAll(
    ".wp-block-artificialsystem-slider"
  );

  async function getAttributes(slideID) {
    try {
      const response = await fetch(
        `/wp-json/artificialsystem/v1/slider/${slideID}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-WP-Nonce": theme_options.nonce,
          },
        }
      );

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Σφάλμα κατά το fetch:", error);
    }
  }

  artificialSliders.forEach(async (slider) => {
    const slideID = slider.attributes.id.value;
    const getSlideOptions = await getAttributes(slideID);
    const slideOptions = getSlideOptions.attributes;

    // set Parameters
    const swiperParams = {
      effect: slideOptions.sliderEffect ? slideOptions.sliderEffect : "fade",
      loop: slideOptions.sliderLoop,
      slidesPerView: slideOptions.slidesPerPage.mobile
        ? slideOptions.slidesPerPage.mobile
        : 1,
      spaceBetween: slideOptions.spaceBetween.mobile
        ? slideOptions.spaceBetween.mobile
        : 0,
      autoplay: {
        delay: slideOptions.sliderAutoplay ? slideOptions.sliderDelay : 99999,
        disableOnInteraction: slideOptions.disableOnInteraction,
        pauseOnMouseEnter: slideOptions.pauseOnMouseEnter,
      },
      speed: slideOptions.sliderSpeed,
      parallax: slideOptions.parallax,
      navigation: {
        enabled: slideOptions.sliderNavigation.mobile,
        nextEl:
          slideOptions.bindSlider == "" || slideOptions.bindSlider == undefined
            ? `#${slideID} .swiper-button-next`
            : `#${slideOptions.bindSlider} .swiper-button-next`,
        prevEl:
          slideOptions.bindSlider == "" || slideOptions.bindSlider == undefined
            ? `#${slideID} .swiper-button-prev`
            : `#${slideOptions.bindSlider} .swiper-button-prev`,
      },
      pagination: {
        enabled: slideOptions.sliderPagination.mobile,
        el: `#${slideID} .swiper-pagination`,
        clickable: true,
      },
      simulateTouch: slideOptions.sliderDraggable,
      breakpoints: {
        // when window width is >= 640px
        640: {
          slidesPerView: slideOptions.slidesPerPage.tablet
            ? slideOptions.slidesPerPage.tablet
            : 2,
          spaceBetween: slideOptions.spaceBetween.tablet
            ? slideOptions.spaceBetween.tablet
            : 20,
          navigation: {
            enabled: slideOptions.sliderNavigation.tablet,
          },
          pagination: {
            enabled: slideOptions.sliderPagination.tablet,
          },
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: slideOptions.slidesPerPage.desktop
            ? slideOptions.slidesPerPage.desktop
            : 1,
          spaceBetween: slideOptions.spaceBetween.desktop
            ? slideOptions.spaceBetween.desktop
            : 0,
          navigation: {
            enabled: slideOptions.sliderNavigation.desktop,
          },
          pagination: {
            enabled: slideOptions.sliderPagination.desktop,
          },
        },
      },
    };

    slideOptions.autoHeight ? (swiperParams["autoHeight"] = true) : "";

    // Initialize Swiper

    if (typeof Swiper === "undefined") {
      const retry = setInterval(() => {
        if (typeof Swiper !== "undefined") {
          initializeSwipers();
          clearInterval(retry);
        }
      }, 100);
    } else {
      initializeSwipers();
    }

    function initializeSwipers() {
      const swiper = new Swiper(`#${slideID} .swiper`, swiperParams);

      // remove aos classes from all Slides, fix delay to slide trransition time
      const slideAosElements = slider.querySelectorAll("[data-aos]");
      slideAosElements.forEach((slideAosElement) => {
        slideAosElement.classList.remove("aos-init", "aos-animate");
        let curDelay = Number(slideAosElement.dataset.aosDelay);
        slideAosElement.dataset.aosDelay = Number(
          curDelay + slideOptions.sliderSpeed
        );
      });

      // add aos classe to active Slide
      const slides = slider.querySelectorAll(".swiper-slide");
      const curSlideAos = slides[0].querySelectorAll("[data-aos]");
      curSlideAos.forEach((aosElement) => {
        aosElement.classList.add("aos-init", "aos-animate");
      });

      // remove animation on slide changes
      swiper.on("slideChange", () => {
        slideAosElements.forEach((slideAosElement) => {
          slideAosElement.classList.remove("aos-init", "aos-animate");
        });
      });

      // add animation on slide changes start
      swiper.on("slideChangeTransitionStart", () => {
        slideAosElements.forEach((slideAosElement) => {
          slideAosElement.classList.add("aos-init", "aos-animate");
        });
      });
    }
    // const swiper = new Swiper(`#${slideID} .swiper`, swiperParams);
  });
});
